import { render, staticRenderFns } from "./FusionGateway.vue?vue&type=template&id=2d203129&scoped=true&"
import script from "./FusionGateway.vue?vue&type=script&lang=js&"
export * from "./FusionGateway.vue?vue&type=script&lang=js&"
import style0 from "./FusionGateway.vue?vue&type=style&index=0&id=2d203129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d203129",
  null
  
)

export default component.exports